module.exports = __webpack_public_path__ + "img/sichuang.d739250c.png";